/** @format */
import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { numberWithCommas } from 'utility';
import { useCurrencyUnit } from 'hooks';
import { PriceLabel } from 'components';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'flex-start',
    position: 'relative',
    padding: '4px 10px',
  },
  title: {
    color: '#1a334d',
    fontSize: '12px',
    background: '#cccccc61',
    padding: '0 7px',
    borderRadius: '48px'
  },
  title2: {
    fontWeight: 'bold',
    color: '#1a334d',
    fontSize: '12px',

  },
  line: {
    border: '1px dashed #d8d8d8',
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    flexGrow: 1,
  },
  ribbonPrice: {
    marginLeft: '8px',
    position: 'absolute',
    right: '-2px',
    backgroundColor: '#2B3990',
    color: 'white',
    padding: '2px 8px',
    borderRadius: '10px 0px 0px 10px',
    fontSize: '10px',
  },
  badgeSuccess: {
    backgroundColor: '#d7ffe2',
    padding: '8px',
    borderRadius: '8px',
    color: '#0e8a38',
  },

  badgeWarning: {
    backgroundColor: '#faeddc',
    padding: '8px',
    borderRadius: '8px',
    color: '#eda74c',
  },
  badgeDanger: {
    backgroundColor: '#f5eeef',
    padding: '8px',
    borderRadius: '8px',
    color: '#F44336',
  },
  textDate: {
    direction: 'rtl',
  },
  textDesc: {
    textAlign: 'justify',
    lineHeight: '23px'
  },


  empty: {},
}));

const TextItemDotted = ({
  title,
  title2,
  type,
  style = {},
  hr = true,
  isPrice = false,
  isBadgeSuccess = false,
  isBadgeWarning = false,
  isBadgeDanger = false,
  isDate = false,
}) => {
  const classes = useStyles();
  const currencyText = useCurrencyUnit(false);
  return (
    <Box mt={1.5} pr={1} className={classes.root} style={{ ...style }}>

      {title && <div className={classes.title}>{title}</div>}
      {/* {hr && <div className={classes.line}></div>} */}
      {hr && type !== 'desc' && <hr className={classes.line} />}
      <div
        //className={classes.title2}
        className={clsx(
          classes.title2,
          `${type !== 'desc' &&
            isBadgeSuccess
            ? classes.badgeSuccess
            : isBadgeWarning
              ? classes.badgeWarning
              : isBadgeDanger ? classes.badgeDanger
                : classes.empty
          }`,
          `${type === 'desc' ? classes.textDesc : ''}`,
          `${isDate ? classes.textDate : ''}`,
        )}
        style={isPrice ? { marginLeft: '32px' } : {}}
      >
        {isPrice ? <PriceLabel amount={title2} /> : title2}
      </div>
      {isPrice && <span className={classes.ribbonPrice}>{currencyText}</span>}
    </Box>
  );
};

export default TextItemDotted;
